<template>
  <main id="unum-main">
    <unum-header />
    <transition :name="transitionName" :mode="transitionMode">
      <router-view class="child-view" />
    </transition>
    <unum-drawer />
    <v-dialog />
  </main>
</template>

<script>
import UnumDrawer from '@/components/layout/Drawer'
import UnumHeader from '@/components/layout/Header'
import { mapActions } from 'vuex'
import { db } from '@/appConfig/appConfig'

export default {
  name: 'UnumMain',
  components: {
    UnumDrawer,
    UnumHeader
  },
  data () {
    return {
      transitionName: 'fade',
      transitionMode: 'out-in',
      platforms: []
    }
  },
  firebase: {
    platforms: db.ref('platforms').orderByChild('published').equalTo(true)
  },
  async created () {
    // this.$bindAsObject(db.ref('platforms').orderByChild('published').equalTo(true));

    // await this.$rtdbBind(db.ref('platforms').orderByChild('published').equalTo(true))
    //   .then((yea)=> {console.log(yea)})
    //   .catch((err)=>{console.log(err)})

    this.setPlatforms(await this.platforms)

    const productsCache = db.ref('blueprints/products').once('value')
      .then(function (productsBluePrint) {
        let productsWithKey = {}
        Object.entries(productsBluePrint.val())
          .forEach(productEntryKey => {
            productsWithKey[productEntryKey[0]] = productEntryKey[1]
          })
        return productsWithKey
      })
    this.$store.dispatch('platforms/setProductsCache', await productsCache)
  },
  methods: {
    ...mapActions('platforms', [
      'setPlatforms',
      'clearCurrentPlatform',
      'clearChosenPlatforms'
    ])
  },
  beforeRouteUpdate (to, from, next) {
    // const toDepth = to.path.split('/').length
    // const fromDepth = from.path.split('/').length
    // this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'

    // if (to.name === 'Session' ||
    //     to.name === 'FinalSelection' ||
    //     to.name === 'Compare' ||
    //     to.name === 'WizardSummary') {
    //   this.transitionName = 'slide-left'
    //   this.transitionMode = null
    // } else if (from.name === 'Session' ||
    //     from.name === 'FinalSelection' ||
    //     from.name === 'WizardSummary') {
    //   this.transitionName = 'slide-right'
    //   this.transitionMode = null
    // } else {
    //   this.transitionName = 'fade'
    //   this.transitionMode = 'out-in'
    // }

    if (
      // from home to Compare/Lookup/Wizard
      (from.name === 'Home' &&
        (to.name === 'Compare' || to.name === 'Lookup' || to.name === 'Wizard')) ||
      (from.name === 'Wizard' && to.name === 'WizardSummary') ||
      (from.name === 'WizardSummary' && to.name === 'Compare') ||
      (from.name === 'Lookup' && to.name === 'Compare') ||
      (to.name === 'FinalSelection') ||
      (from.name === 'Session' && to.name === 'Home')
    ) {
      this.transitionName = 'slide-left'
      this.transitionMode = null
    } else if (
      (from.name === 'WizardSummary' && to.name === 'Wizard') ||
      (from.name === 'Compare' && to.name === 'WizardSummary') ||
      (from.name === 'Compare' && to.name === 'Lookup') ||
      (to.name === 'Home') ||
      (from.name === 'FinalSelection')
    ) {
      this.transitionName = 'slide-right'
      this.transitionMode = null
    } else {
      this.transitionName = 'fade'
      this.transitionMode = 'out-in'
    }

    next()

    // console.log(to)
    // const transition = to.matched.filter(record => record.meta.transition)
    // if (transition[0]) {
    //   console.log(transition[0].meta.transition)
    // }
    // next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#unum-main {
  position: relative;
  overflow: hidden;
  height: 100%;
  @media print {
    overflow: visible;
    height: auto;
  }
}

.fade-enter-active {
  transition: all .5s ease-in-out;
}
.fade-leave-active {
  transition: all .5s ease-in-out
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.child-view {
  height: calc(100% - 8rem);
  position: absolute !important;
  width: 100vw;
  left: 0;
  bottom: 0;
  overflow: hidden;
  @include bp($medium) {
    height: calc(100% - 5rem);
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all .75s ease-in-out;
}
// .slide-left-enter,
// .slide-left-leave-to,
// .slide-right-enter,
// .slide-right-leave-to {
//   opacity: 0;
// }

.slide-left-enter,
.slide-right-leave-to {
  transform: translate3d(100%, 0, 0);
}

.slide-right-enter,
.slide-left-leave-to {
  transform: translate3d(-100%, 0, 0);
}

// .slide-left-enter,
// .slide-right-leave-active {
//   transition: all 15s cubic-bezier(.55,0,.1,1);
//   opacity: 0;
//   transform: translate(100%, 0);
// }

// .slide-left-leave-active,
// .slide-right-enter {
//   transition: all 15s cubic-bezier(.55,0,.1,1);
//   opacity: 0;
//   transform: translate(-100%, 0);
// }
</style>



// WEBPACK FOOTER //
// src/components/layout/Main.vue